import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=a8eba3d4&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=a8eba3d4&lang=scss&scoped=true&"
import style1 from "./CategoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eba3d4",
  null
  
)

export default component.exports